import { forwardRef } from "react";

import { useAdminContentSettingsContext } from "@/search/AdminContentSettingsContext/AdminContentSettingsContext";
import { useSearchAdminPermissions } from "@/search/Langston/useSearchAdminPermissions";
import { useSearchPageContext } from "@/search/Langston/SearchPageProvider";
import { useContentSettings } from "@/search/Langston/useContentSettings";
import useGetUserProperties from "@/users/v3/useGetUserProperties";
import { ContentSettingsToggle } from "./ContentSettingsToggle";
import { visibilityPermissionsContainerCss } from "./VisibilityPermissions.styles";

export const VisibilityPermissions = () => {
  const {
    getters: { sendAdminContentSettings },
    handlers: { setSendAdminContentSettings, refetchSearchResults },
  } = useSearchPageContext();

  const {
    hasContentSettingGroups,
    setApplyPermissionsModalActive,
    disableContentSettingsRef,
    triggerApplyPermissionsModalRef,
    contentSettingsToggleEnabled,
  } = useAdminContentSettingsContext();

  const { canModifyContentSettings } = useGetUserProperties();
  const { invokeContentSettingsSearchModeChange } = useContentSettings();
  const { blockFilterChanges, isContentSettingsFormDirty } =
    useSearchAdminPermissions();

  const handleToggle = () => {
    setSendAdminContentSettings(!sendAdminContentSettings);
    refetchSearchResults();

    if (isContentSettingsFormDirty && blockFilterChanges) {
      setApplyPermissionsModalActive(true);
      disableContentSettingsRef.current = true;
    } else {
      invokeContentSettingsSearchModeChange();
    }
  };

  return (
    <>
      {hasContentSettingGroups && canModifyContentSettings ? (
        <div
          css={visibilityPermissionsContainerCss(contentSettingsToggleEnabled)}
        >
          <ContentSettingsToggle
            checked={contentSettingsToggleEnabled}
            onChange={handleToggle}
            ref={triggerApplyPermissionsModalRef}
          />
        </div>
      ) : null}
    </>
  );
};

export default forwardRef(VisibilityPermissions);
